//@ts-nocheck
import { Route, Routes } from "react-router-dom";
import DashboardLayout from "../layouts/DashboardLayout";
import ActivityLogList from "../pages/ActivityLog/List";
import UserProfile from "../pages/Auth/UserProfile";
import PrivateRoute from "./PrivateRoute";

const Router = () => {
  return (
    <Routes>
      <Route
        element={
          <PrivateRoute>
            <DashboardLayout />
          </PrivateRoute>
        }
      >
        <Route path="/profile/my-profile" element={<UserProfile />} />
        <Route path="/profile" element={<UserProfile />} />
        <Route path="/profile/security" element={<h1>Security</h1>} />
        <Route path="/profile/activity-log" element={<ActivityLogList />} />
        <Route path="/profile/attendence" element={<h1>Attendence</h1>} />
      </Route>
    </Routes>
  );
};

export default Router;

